import React from 'react';

const InputCadastro = ({
  id,
  className,
  campoClassName,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt ${msgErro ? 'erro' : ''} ${campoClassName ? campoClassName : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>
      <div className="input-container">
        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={msgErro ? 'invalid' : ''}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">{msgErro}</div>
    </div>
  );
};

export default InputCadastro;
